export const initFabulatoireFilters = () => {
  const filterRoot = document.querySelector('[data-filter="fabulatoire"]');
  if (!filterRoot) {
    return;
  }

  const cards = Array.from(document.querySelectorAll('.c-card-grid--news .c-card'));
  const buttons = Array.from(filterRoot.querySelectorAll('.c-filter-button'));

    const applyFilter = (value) => {
      buttons.forEach((button) => {
        const isActive = button.dataset.filterValue === value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    cards.forEach((card) => {
      const categories = (card.dataset.categories || '').split(' ').filter(Boolean);
      const show = value === 'all' || categories.includes(value);
      card.classList.toggle('is-hidden', !show);
    });
  };

  filterRoot.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLButtonElement)) {
      return;
    }
    const value = target.dataset.filterValue;
    if (!value) {
      return;
    }
    applyFilter(value);
  });
};
